import React from 'react';

import SendMessageForm from 'scenes/Form/components/SendMessageForm';
import FormDialog from 'scenes/Dialog/components/FormDialog/index';
import ConfirmDialog from 'scenes/Dialog/components/ConfirmDialog/index';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog/index';

import { ENDPOINT } from 'constants/endpoints';
import { MESSAGE_FOLDER } from 'constants/message-types';

export class InboxActions {
  markAsRead = (api, { message, isOpen = true }, { grid }) => {
    if (Number(message.ToRead) === 0) {
      api.post(
        ENDPOINT.ACTION.INBOX.MARK_AS_READ,
        { id: message.MessageID },
        {
          handleError: response => {
            ResponseErrorDialog({ response });
          },
          handleSuccess: response => {
            grid.actions.setData({
              unreadCount: response.unreadCount,
              folders: response.folders,
              rows: grid.data.rows.map(row =>
                row.MessageID === message.MessageID
                  ? {
                      ...row,
                      ToRead: 1,
                      isOpen,
                    }
                  : { ...row }
              ),
            });
          },
        }
      );
    }
  };

  remove = (api, { message }, { grid }) => {
    ConfirmDialog({
      bodyRender: <p>Are you sure you want to delete this message?</p>,
      textSuccessBtn: 'Yes',
      textCancelBtn: 'No',
      dismissWhenClose: true,
    }).then(() => {
      api.post(
        ENDPOINT.ACTION.INBOX.SOFT_DELETE_MESSAGE,
        { id: message.MessageID },
        {
          handleError: response => {
            ResponseErrorDialog({ response });
          },
          handleSuccess: () => grid.actions.fetch(),
        }
      );
    });
  };

  restore = (api, { message }, { grid }) => {
    ConfirmDialog({
      bodyRender: <p>Are you sure you want to restore a message?</p>,
      textSuccessBtn: 'Yes',
      textCancelBtn: 'No',
      dismissWhenClose: true,
    }).then(() => {
      api.post(
        ENDPOINT.ACTION.INBOX.REVERT_MESSAGE,
        { id: message.MessageID, direction: message.Direction },
        {
          handleError: response => {
            ResponseErrorDialog({ response });
          },
          handleSuccess: () => grid.actions.fetch(),
        }
      );
    });
  };

  removePermanently = (api, { message }, { grid }) => {
    ConfirmDialog({
      bodyRender: (
        <p>Are you sure you want to delete this message permanently?</p>
      ),
      textSuccessBtn: 'Yes',
      textCancelBtn: 'No',
      dismissWhenClose: true,
    }).then(() => {
      api.post(
        ENDPOINT.ACTION.INBOX.DELETE_MESSAGE,
        { id: message.MessageID },
        {
          handleError: response => {
            ResponseErrorDialog({ response });
          },
          handleSuccess: () => grid.actions.fetch(),
        }
      );
    });
  };

  reply = (api, message, { grid }) => {
    this.markAsRead(api, { message, isOpen: false }, { grid });

    FormDialog({
      title: 'Reply Message',
      modeless: false,
      compact: true,
      popupStyles: { padding: '0', maxWidth: '800px' },
      popupInnerStyles: { padding: '0 30px' },
      params: {
        id: Number(message.MessageID),
        formType: 'reply',
        recipients: message.FromCandidateID,
      },
      form: (actions, params) => (
        <SendMessageForm actions={actions} params={params} />
      ),
    }).then(null, response => ResponseErrorDialog({ response }));
  };

  forward = (api, message, { grid }) => {
    this.markAsRead(api, { message, isOpen: false }, { grid });

    FormDialog({
      title: 'Forward Message',
      modeless: false,
      compact: true,
      popupStyles: { padding: '0', maxWidth: '800px' },
      popupInnerStyles: { padding: '0 30px' },
      params: {
        id: Number(message.MessageID),
        formType: 'forward',
        hasRecipientsSelection: true,
      },
      form: (actions, params) => (
        <SendMessageForm actions={actions} params={params} />
      ),
    }).then(
      () =>
        grid.data.params.folder === MESSAGE_FOLDER.SENT
          ? grid.actions.fetch()
          : null,
      response => ResponseErrorDialog({ response })
    );
  };

  resumeAccept = (api, { message }, { grid }) => {
    api.post(
      ENDPOINT.ACTION.RESUME_REQUEST_ACCEPT,
      { token: message.ResumeRequestToken },
      {
        handleError: response => {
          ResponseErrorDialog({ response });
        },
        handleSuccess: () => grid.actions.fetch(),
      }
    );
  };

  resumeReject = (api, { message }, { grid }) => {
    api.post(
      ENDPOINT.ACTION.RESUME_REQUEST_DECLINE,
      { token: message.ResumeRequestToken },
      {
        handleError: response => {
          ResponseErrorDialog({ response });
        },
        handleSuccess: () => grid.actions.fetch(),
      }
    );
  };

  connectAccept = (api, { message }, { grid }) => {
    api.post(
      ENDPOINT.ACTION.NETWORK.ACCEPT,
      { token: message.ConnectionRequestToken },
      {
        handleError: response => {
          ResponseErrorDialog({ response });
        },
        handleSuccess: () => grid.actions.fetch(),
      }
    );
  };

  connectReject = (api, { message }, { grid }) => {
    api.post(
      ENDPOINT.ACTION.NETWORK.REJECT,
      { token: message.ConnectionRequestToken },
      {
        handleError: response => {
          ResponseErrorDialog({ response });
        },
        handleSuccess: () => grid.actions.fetch(),
      }
    );
  };
}
